import { useContext } from 'react';
import TranslationContext, {
  TranslationContextType,
} from '../contexts/TranslationContext';

const useTranslation = (): TranslationContextType => {
  return useContext(TranslationContext);
};

export default useTranslation;
